<script>
  import { browser } from "$app/environment";
  import { onMount } from "svelte";
  import { fade } from "$lib/transitions.js";
  import Intersection from "$lib/Intersection.svelte";
  import Image from "$lib/Image.svelte";

  export let block;

  let wrapper;
  let vimeo;

  const [_1, _2, _3, id, h] = block.primary.vimeo.embed_url.split("/");

  let scale = 1;

  const getScale = () => {
    if (!browser) return 1;
    scale = Math.max(
      wrapper.offsetHeight / vimeo.offsetHeight,
      wrapper.offsetWidth / vimeo.offsetWidth,
    );
  };

  onMount(async () => {
    getScale();
  });

  const src = `https://player.vimeo.com/video/${id}?h=${h}&background=true&dnt=true`;
</script>

<svelte:window on:resize={getScale} />
<Intersection let:intersecting top="500" bottom="500">
  <div
    class="video-wrapper relative overflow-hidden w-screen bg-darkgray {block
      .primary.taller
      ? 'taller'
      : ''}"
    bind:this={wrapper}
  >
    <div
      class="absolute vimeo-wrapper w-screen my-auto transform origin-center transition"
      bind:this={vimeo}
      style="transform:scale({scale})"
    >
      <Image
        image={block.primary.fallback}
        class="absolute inset-0 w-full h-full"
        lazy={false}
      />
      {#if browser && intersecting}
        <iframe
          transition:fade|global
          title={block.primary.vimeo.title}
          {src}
          class="absolute inset-0 w-full h-full overflow-hidden"
        />
      {/if}
    </div>
  </div>
</Intersection>

<style lang="postcss">
  .vimeo-wrapper {
    height: 56.25vw;
    top: -200%;
    bottom: -200%;
  }
  .video-wrapper {
    height: 50vh;
    @screen landscape {
      height: 100vh;
    }
    @screen lg {
      height: 50vh;
    }
  }
  .video-wrapper.taller {
    @screen lg {
      height: 70vh;
    }
  }
</style>
